export const MEMBERSHIP_TYPES = {
  monthly: 1,
  annual: 12,
};

export const OFFERS_TIERS_TITLES = {
  core: 'CORE',
  pro: 'PRO',
  ultimate: 'ULTIMATE',
};

export const MEMBERSHIPS_ACTIONS = {
  freeTrial: 'Start Free Trial',
  active: 'Active',
  unavailable: 'Unavailable',
  upgrade: 'Upgrade',
  resubscribe: 'Resubscribe',
  purchasable: 'Buy Now',
};
